import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { Link } from "react-router-dom";
import { Navbar, Nav } from 'rsuite';
import { MdOutlineLogout } from "react-icons/md";

const NavBarComponent = () => {
	const { logout } = useAuth0();
  
	const logoutWithRedirect = () => {
	  logout({
		  returnTo: window.location.origin,
	  });
	};
  
	  return (
        <>
         <Navbar>
         <Link to="/b2b" style={{ textDecoration: 'none' }}>
    <Navbar.Brand>42hacks Mobility Intelligence</Navbar.Brand>
    </Link>
    <Nav pullRight>
      <Nav.Item onClick={() => logoutWithRedirect()} icon={<MdOutlineLogout />}>Logout</Nav.Item>
    </Nav>
  </Navbar>
        </>
	  );
  };
  
  export default NavBarComponent;